import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Qué opciones hay después de la medicación y la terapia?",
    answer:
      "Después de la medicación y la terapia, existen opciones autorizadas por la FDA como la TMS convencional y SAINT® para el trastorno depresivo mayor. SAINT® está indicada para adultos que no han mejorado con antidepresivos. El enfoque se evalúa en una consulta.",
  },
];

export const esWhatComesAfter = makeEsArticle({
  slug: "what-comes-after-medication-and-therapy-for-depression",
  title: "Qué viene después de la medicación y la terapia para la depresión",
  description:
    "Opciones cuando la medicación y la psicoterapia no han funcionado lo suficiente: TMS convencional, SAINT® y otros tratamientos autorizados por la FDA para el trastorno depresivo mayor.",
  h1: "Qué viene después de la medicación y la terapia",
  breadcrumbLabel: "Después de medicación y terapia",
  shortAnswer:
    "Cuando la medicación y la psicoterapia no han producido una mejoría suficiente, existen opciones autorizadas por la FDA para el trastorno depresivo mayor. Estas incluyen la TMS convencional, SAINT® (TMS acelerada con orientación por fMRI) y otros tratamientos. SAINT® está indicada para adultos que no han mejorado con antidepresivos. El enfoque para cada persona se evalúa en una consulta con el equipo clínico.",
  keyTakeaways: [
    "Existen opciones cuando medicación y terapia no han bastado.",
    "La TMS convencional está autorizada por la FDA para la depresión.",
    "SAINT® es TMS acelerada con orientación por fMRI.",
    "SAINT® está indicada para adultos que no han mejorado con antidepresivos.",
    "El enfoque se evalúa en una consulta.",
  ],
  sections: [
    {
      heading: "Opciones posteriores",
      paragraphs: [
        "Cuando la medicación y la psicoterapia no han funcionado lo suficiente, las opciones autorizadas por la FDA para el trastorno depresivo mayor incluyen la TMS convencional y SAINT®. SAINT® administra 50 sesiones en cinco días con orientación individualizada por fMRI y está indicada para adultos que no han mejorado con antidepresivos.",
      ],
    },
    {
      heading: "Cómo se decide",
      paragraphs: [
        "La decisión depende del historial de tratamientos, los síntomas y las preferencias del paciente. Se evalúa en una consulta con el equipo clínico, que incluye una evaluación psiquiátrica para confirmar la elegibilidad.",
        "SAINT® no está indicada para ansiedad, trastorno bipolar, TEPT u otras condiciones. No hay garantías de resultados; los resultados individuales pueden variar.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
